/* JZT – Časté dotazy: rozbalování s animací, hledání, menu kategorií, odkaz přes # */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function normalize(s) {
    s = (s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return s.replace(/\s+/g, ' ').trim();
  }

  function pluralDotaz(n) {
    if (n === 1) return '1 dotaz';
    if (n >= 2 && n <= 4) return n + ' dotazy';
    return n + ' dotazů';
  }

  function setOpen(item, open, animate) {
    var body = item.querySelector('[data-faq-body]');
    if (!body) { item.open = open; return; }
    if (item.open === open && !body.classList.contains('is-animating')) return;
    if (!animate || reduceMotion) {
      body.classList.remove('is-animating');
      body.style.height = '';
      item.open = open;
      return;
    }
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      body.removeEventListener('transitionend', finish);
      body.classList.remove('is-animating');
      body.style.height = '';
      if (!open) item.open = false;
      item.classList.remove('is-closing');
    }
    body.addEventListener('transitionend', finish);
    setTimeout(finish, 450);
    if (open) {
      item.open = true;
      body.style.height = '0px';
      body.classList.add('is-animating');
      // vynutit reflow, aby přechod začal od nuly
      void body.offsetHeight;
      body.style.height = body.scrollHeight + 'px';
    } else {
      item.classList.add('is-closing');
      body.style.height = body.scrollHeight + 'px';
      body.classList.add('is-animating');
      void body.offsetHeight;
      body.style.height = '0px';
    }
  }

  function initFaq(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
    var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-faq-nav]'));
    var searchInput = root.querySelector('[data-faq-search-input]');
    var searchClear = root.querySelector('[data-faq-search-clear]');
    var result = root.querySelector('[data-faq-result]');
    var empty = root.querySelector('[data-faq-empty]');
    var toggleAll = root.querySelector('[data-faq-toggle-all]');

    /* --- rozbalování --- */
    items.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(item, !item.open, true);
      });
    });

    /* --- přilepená hlavička: změř, co překrývá horní okraj --- */
    function measureTop() {
      var probe = document.elementFromPoint(Math.floor(window.innerWidth / 2), 2);
      var top = 0;
      var el = probe;
      while (el && el !== document.body && el !== document.documentElement) {
        if (root.contains(el)) break;
        var pos = window.getComputedStyle(el).position;
        if (pos === 'fixed' || pos === 'sticky') {
          top = Math.max(top, Math.round(el.getBoundingClientRect().bottom));
          break;
        }
        el = el.parentElement;
      }
      root.style.setProperty('--faq-top', top + 'px');
      return top;
    }

    /* --- aktivní kategorie podle scrollu --- */
    var navById = {};
    navLinks.forEach(function (a) { navById[a.getAttribute('data-faq-nav')] = a; });
    var ticking = false;
    function updateActive() {
      ticking = false;
      var top = measureTop();
      var threshold = top + Math.min(window.innerHeight * 0.3, 200);
      var current = null;
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        if (g.hidden) continue;
        var rect = g.getBoundingClientRect();
        if (rect.top <= threshold) current = g;
        if (rect.top > threshold) break;
      }
      if (!current) {
        for (var j = 0; j < groups.length; j++) { if (!groups[j].hidden) { current = groups[j]; break; } }
      }
      navLinks.forEach(function (a) {
        var active = current && a.getAttribute('data-faq-nav') === current.id;
        a.classList.toggle('is-active', !!active);
        if (active) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        if (active && a.scrollIntoView && window.innerWidth < 990) {
          var list = a.parentElement && a.parentElement.parentElement;
          if (list && list.scrollWidth > list.clientWidth) {
            var ar = a.getBoundingClientRect(), lr = list.getBoundingClientRect();
            if (ar.left < lr.left || ar.right > lr.right) {
              list.scrollTo({ left: list.scrollLeft + (ar.left - lr.left) - 16, behavior: reduceMotion ? 'auto' : 'smooth' });
            }
          }
        }
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateActive);
    }
    if (navLinks.length) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateActive();
    } else {
      measureTop();
    }

    /* --- klik v menu: plynulý posun s ohledem na hlavičku --- */
    function scrollToEl(el, extra) {
      var top = measureTop();
      var y = el.getBoundingClientRect().top + window.pageYOffset - top - (extra || 20);
      window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    navLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.getAttribute('data-faq-nav'));
        if (!target) return;
        e.preventDefault();
        if (target.hidden) return;
        scrollToEl(target, 24);
        if (history.replaceState) history.replaceState(null, '', '#' + target.id);
      });
    });

    /* --- rozbalit / sbalit vše --- */
    function visibleItems() { return items.filter(function (it) { return !it.hidden; }); }
    function refreshToggleAll() {
      if (!toggleAll) return;
      var vis = visibleItems();
      var allOpen = vis.length > 0 && vis.every(function (it) { return it.open; });
      toggleAll.textContent = allOpen ? toggleAll.getAttribute('data-label-collapse') : toggleAll.getAttribute('data-label-expand');
      toggleAll.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
    }
    if (toggleAll) {
      toggleAll.addEventListener('click', function () {
        var vis = visibleItems();
        var allOpen = vis.length > 0 && vis.every(function (it) { return it.open; });
        vis.forEach(function (it) { setOpen(it, !allOpen, false); });
        refreshToggleAll();
      });
      root.addEventListener('toggle', refreshToggleAll, true);
      refreshToggleAll();
    }

    /* --- hledání --- */
    var index = items.map(function (it) {
      var q = it.querySelector('.jzt-faq__question');
      var a = it.querySelector('.jzt-faq__answer');
      return {
        item: it,
        group: it.closest ? it.closest('[data-faq-group]') : null,
        text: normalize((q ? q.textContent : '') + ' ' + (a ? a.textContent : ''))
      };
    });
    var lastQuery = '';
    function applySearch(raw) {
      var q = normalize(raw);
      if (q === lastQuery) return;
      lastQuery = q;
      var words = q ? q.split(' ') : [];
      var shown = 0;
      var groupCounts = {};
      index.forEach(function (entry) {
        var hit = true;
        for (var i = 0; i < words.length; i++) {
          if (entry.text.indexOf(words[i]) === -1) { hit = false; break; }
        }
        entry.item.hidden = !hit;
        if (hit) {
          shown++;
          if (entry.group) groupCounts[entry.group.id] = (groupCounts[entry.group.id] || 0) + 1;
        }
      });
      groups.forEach(function (g) {
        var n = q ? (groupCounts[g.id] || 0) : g.querySelectorAll('[data-faq-item]').length;
        g.hidden = q ? n === 0 : false;
        var a = navById[g.id];
        if (a) {
          a.classList.toggle('is-empty', q ? n === 0 : false);
          var c = a.querySelector('[data-faq-nav-count]');
          if (c) c.textContent = n;
        }
      });
      if (empty) empty.hidden = !(q && shown === 0);
      if (result) result.textContent = q ? (shown ? 'Nalezeno: ' + pluralDotaz(shown) : '') : '';
      if (searchClear) searchClear.hidden = !q;
      if (q && shown > 0 && shown <= 5) {
        index.forEach(function (entry) { if (!entry.item.hidden && !entry.item.open) setOpen(entry.item, true, false); });
      }
      refreshToggleAll();
      updateActive();
    }
    if (searchInput) {
      var timer = null;
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { applySearch(searchInput.value); }, 120);
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { searchInput.value = ''; applySearch(''); }
      });
      if (searchClear) {
        searchClear.addEventListener('click', function () {
          searchInput.value = '';
          applySearch('');
          searchInput.focus();
        });
      }
    }

    /* --- otevření podle #odkazu --- */
    function openFromHash() {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      var id;
      try { id = decodeURIComponent(hash.slice(1)); } catch (e) { id = hash.slice(1); }
      var target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      if (target.hasAttribute('data-faq-item')) {
        if (searchInput && searchInput.value) { searchInput.value = ''; applySearch(''); }
        setOpen(target, true, false);
      }
      setTimeout(function () { scrollToEl(target, 24); }, 60);
    }
    window.addEventListener('hashchange', openFromHash);
    openFromHash();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-jzt-faq]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-faq-ready')) continue;
      roots[i].setAttribute('data-faq-ready', '1');
      initFaq(roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // editor motivu Shopify znovu vykreslí sekci
  document.addEventListener('shopify:section:load', boot);
})();
